import { DATA_START_ROW, DB_SHEET_NAME, LAST_COLUMN_LETTER, } from "../../const/excel.const";
import { makeHeader } from "../header";
import { addNumFormat, addPriceFormat } from "../../utils/add-num-format";
const countRowsByClassification = (sheet, filterKey) => {
    let count = 0;
    sheet.eachRow((row, rowNumber) => {
        if (rowNumber < DATA_START_ROW)
            return;
        const classification = row.getCell(2).value?.toString() ?? "";
        if (classification === filterKey)
            count += 1;
    });
    return count;
};
export function makeViewerSheets(workbook, productClassificationInfo) {
    const dbSheet = workbook.getWorksheet(DB_SHEET_NAME);
    if (!dbSheet) {
        throw new Error(`시트 "${DB_SHEET_NAME}"를 찾을 수 없습니다.`);
    }
    productClassificationInfo.forEach((sheetInfo) => {
        const sheet = workbook.addWorksheet(sheetInfo.name);
        makeHeader(sheet);
        const matchedRowCount = countRowsByClassification(dbSheet, sheetInfo.filterKey);
        const spillRowCount = Math.max(matchedRowCount, 0);
        const endRow = DATA_START_ROW + spillRowCount - 1;
        const spillRef = spillRowCount === 0
            ? `A${DATA_START_ROW}`
            : `A${DATA_START_ROW}:${LAST_COLUMN_LETTER}${endRow}`;
        const cell = sheet.getCell("A2");
        const formula = `IFERROR(_xlfn.FILTER('${DB_SHEET_NAME}'!A:${LAST_COLUMN_LETTER},'${DB_SHEET_NAME}'!B:B="${sheetInfo.filterKey}"),"필터된 제품 없음")`;
        cell.value = {
            formula,
            shareType: "array",
            ref: spillRef,
        };
        addNumFormat(sheet, `Q2`, `IFERROR(SUM(I:I), 0)`);
        addPriceFormat(sheet, `R2`, `IFERROR(SUM(M:M), 0)`);
    });
}
